<template>
  <div class="confirm">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="amount">
          <p>到账金额（美元）</p>
          <span
            v-if="rechargeData && rechargeData.amountInUSD"
          >${{ rechargeData.amountInUSD }}</span>
          <p
            v-if="
              (rechargeData && rechargeData.amount && rechargeData.rate) ||
                rechargeData.gatewayAmount != ''"
            class="color"
          >
            合计{{
              rechargeData.gatewayAmount != ""
                ? rechargeData.gatewayAmount
                : usdtPayIDsMap['USDT - 2'].includes(rechargeData.payMethod)
                  ? Math.round(Utils.accMul(rechargeData.amount, rechargeData.rate) * 100) / 100
                  : Utils.roundUp(Utils.accMul(rechargeData.amount, rechargeData.rate),
                                  0
                  ).toFixed(2)
            }}
            <!-- {{ displayCurrency === "USDT" ? "USDT" : "人民币" }} -->
            {{ getDisplayCurrencyText(displayCurrency) }}
          </p>
        </div>
        <div class="orderList">
          <ul>
            <li>
              <p>存款账号</p>
              <span>{{ user.loginname }}</span>
            </li>
            <li>
              <p>付款方式</p>
              <span v-if="rechargeData && rechargeData.payName">{{
                rechargeData.payName
              }}</span>
            </li>
          </ul>
        </div>
        <div
          v-sa="{
            deposit_confirmation: {
              PType:
                pageType == 'app'
                  ? 'app端'
                  : pageType == 'trade'
                    ? 'H5交易'
                    : '用户中心',
              AccountType: '真实账户',
              deposit_amount: rechargeData.amount,
              payment_channel: rechargeData.payName,
              account: user.loginname,
            },
          }"
          class="submit"
          @click="submit"
        >
          <span>确认存款</span>
        </div>
        <div v-if="otcIDs.includes(rechargeData.payMethod)" class="warning">
          <span>温馨提示：存款过程请保留截图，如本次无法成功存款可提供截图客服查看。  请勿多次尝试提交， 避免户口锁定。</span>
        </div>
      </div>
      <Chat />
    </div>
    <FundRichfullDeposit
      v-if="isFundRichfullDeposit"
      :encrypted-text="encryptedText"
      :merchant-id="merchantId"
      :signed-text="signedText"
      :submit-u-r-l="submitURL"
    />
  </div>
</template>

<script>
require('@/assets/css/confirm.css')
import Header from '@/view/module/Header.vue'
import FundRichfullDeposit from '@/view/recharge/FundRichfullDeposit.vue'
import Chat from '@/view/module/Chat.vue'
import api from '@/plugins/api'
import utils from '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
import { getDisplayCurrencyText } from '@/utils/helper'
export default {
  name: 'RechargeConfirm',
  components: { Header, FundRichfullDeposit, Chat },
  computed: {
    ...mapState(['user', 'platform', 'currency', 'rechargeData', 'pageType']),
    depositParam: {
      get() {
        if (this.payCode == 0) {
          return {
            platform: this.platform,
            amount: this.rechargeData.amount,
            payMethod: this.rechargeData.payMethod,
            depositCurrency: this.currency,
            bqwaytype: this.rechargeData.bqwaytype,
            fee: 0
          }
        }
        // } else if (this.payCode == 1) {
        return {
          platform: this.platform,
          amount: this.rechargeData.amount,
          payMethod: this.rechargeData.payMethod,
          depositCurrency: this.currency,
          bqwaytype: this.rechargeData.bqwaytype,
          bank: this.rechargeData.payDictCode,
          bankAccountNumber: this.rechargeData.bankAccountNumber,
          gatewayAmount: this.rechargeData.gatewayAmount,
          payCurrency: this.rechargeData.payCurrency,
          fee: 0
        }
        // }
      }
    },
    usdtPayIDsMap: function() {
      const usdtPayIDsObj = JSON.parse(this.usdtPayIDsStr)
      Object.keys(usdtPayIDsObj).forEach(function(key) {
        usdtPayIDsObj[key] = String(usdtPayIDsObj[key]).split(',').map(id => Number(id))
      })
      return usdtPayIDsObj
    },
  },
  data() {
    return {
      title: '确认存款',
      rightContent: 'recharge',
      Utils: utils,
      isFundRichfullDeposit: false,
      encryptedText: '',
      merchantId: '',
      signedText: '',
      submitURL: '',
      payCode: this.$route.query.payCode || 0,
      displayCurrency: this.$route.query.currency,
      usdtPayIDsStr: process.env.VUE_APP_USDT_PAY_IDS,
      getDisplayCurrencyText,
      otcIDs: process.env.VUE_APP_OTC_IDS.split(',').map(id => Number(id))
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    submit() {
      this.$bus.$emit('loading', false)
      const readyData = this.depositParam
      api.addDeposit(readyData).then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data && res.data.data.mpayPara) {
              const data = res.data.data.mpayPara
              this.isFundRichfullDeposit = true
              this.encryptedText = data.encryptedText
              this.merchantId = data.merchantId
              this.signedText = data.signedText
              this.submitURL = data.submitURL
            }
          }
        }
      })
    }
  }
}
</script>
